// src/admin/utils/money.ts — Ngwee is the atomic integer unit. 1 Kwacha = 100 ngwee.
import type { Ngwee } from '@/lib/types';

export function formatKwacha(amount: Ngwee, opts: { showUnit?: boolean; decimals?: 0 | 2 } = {}): string {
  const { showUnit = true, decimals = 2 } = opts;
  const kwacha = Number(amount) / 100;
  const formatted = kwacha.toLocaleString('en-ZM', {
    minimumFractionDigits: decimals, maximumFractionDigits: decimals,
  });
  return showUnit ? `K ${formatted}` : formatted;
}

export function kwachaStringToNgwee(str: string): Ngwee | null {
  const cleaned = str.replace(/[^\d.-]/g, '');
  if (cleaned === '' || cleaned === '-' || cleaned === '.') return null;
  const n = Number(cleaned);
  if (!Number.isFinite(n)) return null;
  const ngwee = Math.round(n * 100);
  if (!Number.isInteger(ngwee)) return null;
  return ngwee as Ngwee;
}

export function ngweeToKwachaNumber(amount: Ngwee): number {
  return Number(amount) / 100;
}
